import React from 'react';
import ErrorPage from '../../pages/error-page/error-page';

function Error() {
    return (
        <>
            <ErrorPage />
        </>
    );
}

export default Error;
